import {ImportLogList} from "./ImportLogList.tsx";

export const ImportPage = () => {
    return <>
        <h1>Import Log</h1>
        <ImportLogList/>
    </>
}